export const ENVIRONMENT = process.env.NODE_ENV || 'development'

// Warning: `NODE_ENV` could be "test", as it is automatically set by Jest
// during our tests.
// Read more: https://jestjs.io/docs/en/22.x/getting-started.html#using-babel
export const IS_DEVELOPMENT = ENVIRONMENT === 'development'
export const IS_PRODUCTION = ENVIRONMENT === 'production'
export const IS_TEST = ENVIRONMENT === 'test'

/**
 * @param {string | undefined} envValue
 * @param {boolean} defaultValue
 * @returns {boolean}
 */
export function envToBoolean(envValue, defaultValue) {
  switch (envValue) {
    case 'true':
      return true
    case 'false':
      return false
    default:
      return defaultValue
  }
}
